import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import DefaultAvatar from '@/assets/img/userIconGeneric.png';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userDisplayName: null,
    username: '',
    storageKey: '@blitzar.token',
    menuClosed: true,
    eventId: '',
    eventName: '',
    user: {
      token: '',
      isLogged: false,
      name: '',
      nickname: '',
      email: '',
      picture: DefaultAvatar,
      id: null,
      role: null,
      language: 'pt',
      inMeeting: false,
      level: 0,
      isFirstLogin: false,
    },
    template: {
      multilanguagesConfig: false,
      titleAlign: 'center',
    },

    markers: {
      answeredPolls: [],
      answeredQuiz: [],
      answeredEssay: [],
    },

    foyerLoaded: false,
    availableActivities: [],
    acceptedLegal: false,
    unicoCheckSDK: null,
  },
  plugins: [createPersistedState()],
  mutations: {
    toggleMenu(state) {
      state.menuClosed = !state.menuClosed;
    },
    initializeStore(state) {
      if (localStorage.getItem('acceptedLegal')) {
        state.acceptedLegal = true;
      }
    },
    acceptedLegal(state) {
      localStorage.setItem('acceptedLegal', true);
      state.acceptedLegal = true;
    },
    setUser(state, payload) {
      const userData = payload.userData;
      //console.log('UserData:',userData);
      if (userData) {
        state.user.name = userData.name;
        state.user.nickname = userData.nickname;
        state.user.email = userData.email;
        state.user.token = userData.sessionId;
        state.user.tokenJWT = userData.token;
        state.user.id = userData.userId;
        state.user.role = userData.event_user_role_id;
        state.user.level = userData.level;
        state.user.isLogged = true;
        state.user.picture = userData.image || DefaultAvatar;
        state.user.isFirstLogin = userData.firstLogin;

        localStorage.setItem(state.storageKey, JSON.stringify(userData));
      } else {
        throw 'UserData is empty';
      }
    },
    setUserRole(state, payload) {
      state.user.role = payload.role;
      state.user.level = payload.level;
    },
    setUserName(state, name) {
      state.user.name = name;
    },
    setUserNickname(state, nickname) {
      state.user.nickname = nickname;
    },
    setUserPicture(state, image) {
      state.user.picture = image;
    },
    setUserEmail(state, email) {
      state.user.email = email;
    },
    setUserLanguage(state, language) {
      state.user.language = language.toLowerCase();
    },
    setUserInMeeting(state, inMeeting) {
      state.user.inMeeting = inMeeting;
    },
    resetUser(state) {
      // Preserve user's language preference across resets
      const currentLanguage = state.user.language || 'pt';

      state.user = {
        token: '',
        isLogged: false,
        name: '',
        nickname: '',
        picture: DefaultAvatar,
        id: null,
        role: null,
        language: currentLanguage,
        inMeeting: false,
        level: 0,
        isFirstLogin: false,
      };
      localStorage.setItem('@blitzar.token', null);
    },
    setTemplate(state, payload) {
      let config, home;

      try {
        config = JSON.parse(payload.config);
      } catch (err) {
        config = {};
      }

      try {
        home = JSON.parse(payload.home);
      } catch (err) {
        home = {};
      }

      state.template = {
        ...state.template,
        ...config,
        home,
      };
    },
    setEvent(state, data) {
      state.eventId = data.event_id;
      state.eventName = data.name;
    },
    setMarker(state, { target, marker }) {
      state.markers[target] = [...state.markers[target], marker];
      state.markers[target] = [...new Set(state.markers[target])];
    },
    setActivities(state, payload) {
      state.availableActivities = payload.activities;
      state.foyerLoaded = true;
    },
    setMenu(state, payload) {
      let menu = {};
      try {
        menu = payload;
      } catch (err) {
        menu = {};
      }

      state.template = {
        ...state.template,
        menu,
      };
    },
    setAgenda(state, payload) {
      let agenda = {};
      try {
        agenda = payload;
      } catch (err) {
        agenda = {};
      }

      state.template = {
        ...state.template,
        agenda,
      };
    },
    buildUnicoCheckSDK(state, payload) {
      state.unicoCheckSDK = payload;
    },
  },
  actions: {},
  modules: {},
});
